import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  

  <span style="color:#85c1dc;">**FI:**</span>
  Kokonaishinta ilman veroja \(<span style="color:#a6d189;">**{vat}**</span>%\)

  <span style="color:#85c1dc;">**RU:**</span>
  
*/
/* @__NO_SIDE_EFFECTS__ */
const m1573 = msg(
  mf``,
  mf`Kokonaishinta ilman veroja (${'vat'}%)`,
  mf``,
)

export { m1573 as 'w.basket.summary.without_tax' }